export default __webpack_public_path__ + "static/5-dbed237a39659f8522d4f08b6b3656b5.jpeg";